export enum UsersTypes {
  GET_ALL_DATA_USERS = 'GET_ALL_DATA_USERS',
  GET_DATA_USERS = 'GET_DATA_USERS',
  GET_USER = 'GET_USER',
  SET_LOADING_USER = 'SET_LOADING_USER',
  LOGOUT = 'LOGOUT'
}